import "bootstrap/dist/css/bootstrap.css";
import "antd/dist/antd.css";
import "./styles/style-fonts.css";
import "./styles/index.scss";
import "./styles/custom.scss";
import { registerables, Chart } from "chart.js";
import { Route, Routes, useNavigate } from "react-router-dom";
import { getAllContactList, getDispositionForCustomers, getNecessaryDetails, getQueueeList, getTagsForCustomers } from "./store/api/helperspi/contactListapiService";
import { ActivityInfo } from "./initialsetup/ContactDetails/activity/activity";
import { CallService } from "./services/call_service";
import Draggable from "react-draggable";
import { GetItemFromStorage, SetItemInStorage } from "./custom_hooks/useStorage";
import { LocalStorage } from "./custom_hooks/localStorageKeys";

import OncallPad from "./webchat/oncallpad";
import ShortCutKeys from "./shortcutkeyFunction/shortCutKeysFunction";
import { PublicRoutes } from "./routes/routes_constants";
import { QueueList } from "./components/main_layout/navigation/settings/basic_configuration/custom_queue/queueList";
import { ShortcutKeys } from "./components/shortcutkeys/shortcutkeys";
import callChatService from "./base/service/chatService";
import { getAllUsers } from "./store/api/user_management";
import store from "./store/redux-store/root_store";
import styles from "./shared/widges/agentTransfer/agentTransfer.module.scss";
import { updateAgentState } from "./store/api/agent_status";
import { useDispatcher } from "./custom_hooks/use_app_dispatch";
import { useEffect, useState, lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import { LoginActions } from "./store/slices/authentication_slice/login_slice";
import axios from "axios";
import { ChatActions } from "./store/slices/chat_slice/chat_slice";
import { Button, Modal } from "antd";
import { CallPopUpAgentActions } from "./store/slices/voice_call_slice/call_popup_agent";
import { config, getDynamicTitle, ROLES } from "./base/constant";
import { useSearchParams } from 'react-router-dom';
import presenceService from "./base/service/presence";
import { CommonContainer } from "./commonContainer/common-container";
import { ChatLimit } from "./components/main_layout/navigation/settings/basic_configuration/chatLimit";
import { videoCallService } from "./base/service/videoCallService";
import { BigcommerceLoad } from "./components/connectors/bigCommerce/bigcommerceLoad";
import WixStoreCheck from "./components/connectors/wix/storeCheck";
import { CoreServices, MeetServices } from "./base/service/apiServices";
import ControlledRoutes from './routes/controlled_routes';
import { updateVirtualBGRedux } from "./base/video_common";

import Loaders from "./components/loader/loader";
import Login from './components/login';
import IncomingCallNotify from './components/webChatScreen/incomingcallNotify';
import IncomingChatNotify from './components/webChatScreen/incomingchatNotify';
import IncomingEmailNotify from './components/webChatScreen/incomingemailNotify';
import SocialmediaWidget from './components/webChatScreen/incomingSocialmediaNotify';
import IncomingVideoCallNotify from './components/webChatScreen/incomingvideocallNotify';
import CallWhisper from "./shared/widges/callwhisper";
import CsatFeedComponent from "./components/main_layout/navigation/settings/general_settings/customer_satisfaction/CustomerFeedbackForm";
import SupervisorWhisperStatus from "./components/webChatScreen/supervisorWhisperStatus";
import WixOauthConnect from './components/connectors/wix/oauthConnectionPage';
import ConnectorSuccesspage from "./components/connectors/successpage";
import StoreToken from "./components/connectors/zendeskSupport/storeToken";
import Verificationmodal from "./components/webChatScreen/chatWidgets/chatLeftSidebar/verificationmodal/index.tsx";

import ConnectorUnSuccesspage from "./components/connectors/unSuccessPage";
// import Callblast from "./callblast/callblast";
// import PredictiveDialler from"./predictivedialler/callblast";
// import Personalindextab from "./callblast/personalindextab";
// import PredictivediallerPersonalindextab from "./predictivedialler/personalindextab";
import Skeleton from "./components/contact/addcontact/Skeleton";
import Tablecom from "./components/tablecomp/tablecom";
import { useMediaQuery } from "react-responsive";
import WebChatScreen from "./components/webChatScreen";
import { MainLayout } from "./components/mainpage";
import { outboundCampaignSliceAction } from "./store/slices/outboundCampaign/outboundCampaignslice";
import Cardwrapper from "./components/cardwrapper/cardwrapper";
import Knowledgebaseupgrade from "./components/knowledgebase/knowledgebaseupgrade";
import Usereports from "./components/reports/usereports";



const Dynamicdashindexanimated = lazy(() => import('./dynamicdashboard/dynamicdash'));
// const MainLayout = lazy(() => import('./components/mainpage').then(module => ({ default: module.MainLayout })));
const ContactScreen = lazy(() => import('./components/contact'));
const OauthAppList = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/oauth_app').then(module => ({ default: module.OauthAppList })));
const PrivateApp = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/privateapp').then(module => ({ default: module.PrivateApp })));
const EmailConfig = lazy(() => import("./components/main_layout/navigation/settings/basic_configuration/emailconfiguration").then(module => ({ default: module.EmailConfig })));
const CreateCustomQueue = lazy(() => import("./components/main_layout/navigation/settings/basic_configuration/custom_queue/create_custom_queue").then(module => ({ default: module.CreateCustomQueue })));
const ChatFlowList = lazy(() => import("./components/main_layout/navigation/chatbot/ChatFlowList").then(module => ({ default: module.ChatFlowList })));
const CallFlow = lazy(() => import("./components/main_layout/navigation/settings/basic_configuration/callflow").then(module => ({ default: module.CallFlow })));
const CallFlowTableList = lazy(() => import("./components/main_layout/navigation/settings/basic_configuration/callflow/callflowtablelist").then(module => ({ default: module.CallFlowTableList })));
const SupervisorProfileForm = lazy(() => import("./components/main_layout/navigation/contacts/supervisor_contacts/supervisor_contact_list/supervisor_Create_form/create_form").then(module => ({ default: module.SupervisorProfileForm })));
const SupervisorTableList = lazy(() => import("./components/main_layout/navigation/contacts/supervisor_contacts/supervisor_contact_list/supervisortablelist/SupervisorViewList").then(module => ({ default: module.SupervisorTableList })));
const SuspendedEmails = lazy(() => import("./components/main_layout/navigation/settings/basic_configuration/emailconfiguration/suspendedEmail").then(module => ({ default: module.SuspendedEmails })));
const UserManagemantList = lazy(() => import("./components/main_layout/navigation/settings/basic_configuration/user_management/userManagementList").then(module => ({ default: module.UserManagemantList })));
const Usermanagement = lazy(() => import("./components/main_layout/navigation/settings/basic_configuration/user_management/user-management").then(module => ({ default: module.Usermanagement })));
const SupervisorBlock = lazy(() => import("./components/main_layout/navigation/contacts/supervisor_contacts/supervisor_block/supervisor_block_list/supervisor_block_list").then(module => ({ default: module.SupervisorBlock })));
const SupervisorDND = lazy(() => import("./components/main_layout/navigation/contacts/supervisor_contacts/supervisor_Dnd/supervisor_Dnd_list/SupervisorDNDlist").then(module => ({ default: module.SupervisorDND })));
const SupervisorDNDview = lazy(() => import("./components/main_layout/navigation/contacts/supervisor_contacts/supervisor_Dnd/Supervisor_Dnd_form/supervisordndview").then(module => ({ default: module.SupervisorDNDview })));
const SupervisorLeftUser = lazy(() => import("./components/main_layout/navigation/contacts/supervisor_contacts/supervisor_block/supervisor_block_form/supervisor_block_form").then(module => ({ default: module.SupervisorLeftUser })));
const AddWorktualSupportAddress = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/emailconfiguration/addworktualsupportaddress'));
const AddsupportSupport = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/emailconfiguration/addsupportaddress'));
const AdminDashboard = lazy(() => import('./components/main_layout/navigation/admindashboard'));
const AgentDashboard = lazy(() => import('./components/main_layout/navigation/agentdashboard'));
const AgentRouting = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/routing_profile/agent-routing'));
const AgentStatusDetails = lazy(() => import('./components/main_layout/navigation/settings/general_settings/agent_status/agentDetails'));
const AgentStatusDetailsView = lazy(() => import('./components/main_layout/navigation/settings/general_settings/agent_status/agentDetailsView'));
const AgentStatusList = lazy(() => import('./components/main_layout/navigation/settings/general_settings/agent_status'));
const AllActivityMain = lazy(() => import('./voicecall/allactivitymain'));
const Analytics = lazy(() => import('./components/main_layout/navigation/Analytics'));
const AnsweredCallReports = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/reports/answered_call_report'));
const BusinessHours = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/business_hours'));
const ChatsReport = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/reports/ChatsReport'));
const CoChat = lazy(() => import('./components/cochat'));
const ContactCenterNumber = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/contact_center_numbers'));
const CreateBusinessHours = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/business_hours/createBusinessHours'));
const CreateWebChatWidget = lazy(() => import('./components/webChat/createWebChat'));
const CustomerTag = lazy(() => import('./components/main_layout/navigation/settings/general_settings/customer_tags'));
const DashboardReport = lazy(() => import('./components/main_layout/navigation/admindashboard/agentReport'));
const DispositionStatusDetails = lazy(() => import('./components/main_layout/navigation/settings/general_settings/disposition_status/dispositionDetails'));
const DispositionStatusList = lazy(() => import('./components/main_layout/navigation/settings/general_settings/disposition_status'));
const EmailChannelNew = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/emailChannel'));
const NotFound = lazy(() => import('./components/login/notFound'));
const PlayPromtNew = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/playPrompt/playPromt'));
const ResetPassWord = lazy(() => import('./components/login/resetpassword'));
const RoutingProfile = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/routing_profile'));
const Settings = lazy(() => import('./components/settings'));
const SkillManagement = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/skillmanagement'));
const SmsListNumber = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/SMS'));
const SpriteIcons = lazy(() => import('./spriteIcons'));
const SupervisorProfileContact = lazy(() => import('./components/main_layout/navigation/contacts/supervisor_contacts/supervisor_contact_list/edit_page'));
const VerifySupportAddress = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/emailconfiguration/verifysupportaddress'));
const VerifyWorktualSupportAddress = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/emailconfiguration/verifyworktualsupportaddress'));
const ViewBusinessHours = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/business_hours/constants'));
const WebChatAgentChatReport = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/reports/webchat_agent_chat_report'));
const WebChatList = lazy(() => import('./components/webChat/webChatList'));
const WebChatMain = lazy(() => import('./webchat'));
const ChatBot = lazy(() => import('./components/main_layout/navigation/chatbot'));
const ChatFlow = lazy(() => import('./components/main_layout/navigation/chatbot/chatflow'));
const AgentDashboardReport = lazy(() => import('./components/main_layout/navigation/agentdashboard/agentReport'));
const WebSiteURL = lazy(() => import('./components/main_layout/navigation/chatbot/botsetting/websiteurl'));
const ConnectorsMain = lazy(() => import('./components/connectors'));
const ConnectorsInner = lazy(() => import('./components/connectors/connectors'));
const ContactConnector = lazy(() => import('./components/connectors/contact'));
const ContactForm = lazy(() => import('./components/connectors/contactnew'));
const ApiIntegration = lazy(() => import('./components/apiIntegration'));
const CreateApi = lazy(() => import('./components/apiIntegration/createapi'));
const ApiInner = lazy(() => import('./components/apiIntegration/apiinners'));
const OauthClient = lazy(() => import('./components/apiIntegration/oauthClient'));
const AddClient = lazy(() => import('./components/apiIntegration/addClient'));
const EndpointDetails = lazy(() => import('./components/apiIntegration/endpointDetails'));
const ConnectorSubModule = lazy(() => import('./components/connectors/submodule'));
const Voicerecordings = lazy(() => import('./voicesettings'));
const ChannelConfigMain = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/channelconfig'));
const UpdatewhatsappAcc = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/whatsapp/addwhatsappacc'));
const WhatsappDemo = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/whatsapp'));
const Facebook = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/facebook'));
const UpdatefacebookAcc = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/facebook/updatefacebookacc'));
const Addfacebookacc = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/facebook/addfacebookacc'));
const Instagram = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/instagram'));
const UpdateinstagramAcc = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/instagram/updateinstagramacc'));
const AddInstagramacc = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/instagram/addinstagramacc'));
const SmsUpdate = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/SMS/smsUpdate'));
const ChannelReportsMain = lazy(() => import('./components/reports/channel'));
const KnowledgebaseInner = lazy(() => import('./components/knowledgebase/knowledgebaseinner'));
const KnowledgeBase = lazy(() => import('./components/knowledgebase'));
const SettingsMain = lazy(() => import('./components/main_layout/navigation/settings'));
const EditClient = lazy(() => import('./components/apiIntegration/editclient'));
const FlowScreen = lazy(() => import('./components/flows'));
const APIConfiguration = lazy(() => import('./components/apiIntegration/apiConfiguration'));
const StandAloneMain = lazy(() => import('./components/main_layout/navigation/standAloneDashboard'));
const AgentDashBoardKelvin = lazy(() => import('./components/main_layout/navigation/standAloneDashboard/agentDashBoardKelvin'));
const ApiContactSync = lazy(() => import('./components/apiIntegration/apicontactsync'));
const ReportsMenuSidebar = lazy(() => import('./components/mainpage/reportsmenusidebar'));
const Agentreportsmain = lazy(() => import('./components/reports'));
const CallConfig = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/callflow/callConfig'));
const CreateCall = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/callflow/createCallConfig'));
const EditCall = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/callflow/editCallConfig'));
const LeadGenration = lazy(() => import('./components/main_layout/navigation/settings/general_settings/leadgeneration'));
const ContactDetailsScreen = lazy(() => import('./components/contact/contactDetails'));

const AttachmentDetails = lazy(() => import('./components/contact/attachmentsdetails'));

const ManageDuplicate = lazy(() => import('./components/contact/manageDuplicate/manageDuplicate'));
const ConnectorList = lazy(() => import('./components/connectors/connectorsList'));
const ConnectorCompanyList = lazy(() => import('./components/connectors/connectorsCompanyList'));
const AIBotreportsmain = lazy(() => import('./components/reports/aIbotreports'));
const ShopifyConnectionList = lazy(() => import('./components/connectors/shopify'));
const XeroConnectionList = lazy(() => import('./components/connectors/xero'));
const ShopifyNewConnection = lazy(() => import('./components/connectors/shopify/newconnection'));
const PaymentMethods = lazy(() => import('./components/main_layout/navigation/settings/payment_methods'));
const PayPal = lazy(() => import('./components/main_layout/navigation/settings/payment_methods/paypal'));
const PayPalBraintree = lazy(() => import('./components/main_layout/navigation/settings/payment_methods/paypalbraintree'));
const GlobalPayment = lazy(() => import('./components/main_layout/navigation/settings/payment_methods/globalpayment'));
const Stripe = lazy(() => import('./components/main_layout/navigation/settings/payment_methods/stripe'));
const ChatbotOnboarding = lazy(() => import('./components/webChat/chatbotOnboarding'));
const ContactSettings = lazy(() => import('./components/main_layout/navigation/settings/contact_settings'));
const Square = lazy(() => import('./components/main_layout/navigation/settings/payment_methods/square'));
const Razorpay = lazy(() => import('./components/main_layout/navigation/settings/payment_methods/razorpay'));
const MagentoConnectionList = lazy(() => import('./components/connectors/magento'));
const MagentoNewConnection = lazy(() => import('./components/connectors/magento/newconnection'));
const ZendeskSupportNewConnection = lazy(() => import('./components/connectors/zendeskSupport/newconnection'));
const ZendeskConnectionList = lazy(() => import('./components/connectors/zendeskSupport'));
const RestrictedContact = lazy(() => import('./components/contact/restrictedContacts'));
const KnowledgebaseEdit = lazy(() => import('./components/knowledgebase/knowledgebaseedit'));
const HubspotConnectors = lazy(() => import('./components/connectors/hubspot'));
const HubSpotConnection = lazy(() => import('./components/connectors/hubspot/hubspotConnection'));
const VideoMeetingCustomer = lazy(() => import('./components/joinMeetingScreen/videomeetingcustomer'));
const EmailTemplate = lazy(() => import('./components/chatRightBar/createEmail'));
const AgentFullScreen = lazy(() => import('./components/joinMeetingScreen/agentFullScreen/agentFullScreenComponent'));
const BigCommerceConnection = lazy(() => import('./components/connectors/bigCommerce/bigCommerceConnection'));
const GoogleSheetConnection = lazy(() => import('./components/connectors/googleSheet/index'));
const EditorOne = lazy(() => import('./components/editor'));
const AgentanalyticsMain = lazy(() => import('./components/main_layout/navigation/Analytics/widgets/agentanalystics/AgentAnalytics'));
const BigcommerceConnectionList = lazy(() => import('./components/connectors/bigCommerce/bigcommerceConnList'));
const NewConnection = lazy(() => import('./components/connectors/woocommerce/newConnection'));
const WoocommerceList = lazy(() => import('./components/connectors/woocommerce'));
const Customersatisfaction = lazy(() => import('./components/main_layout/navigation/settings/general_settings/customer_satisfaction'));
const CustomersatisfactionCreate = lazy(() => import('./components/main_layout/navigation/settings/general_settings/customer_satisfaction/customerSatisfactionCreate'));
const CustomersatisfactionEmail = lazy(() => import('./components/main_layout/navigation/settings/general_settings/customer_satisfaction/csatEmailComponent'));
const WixConnection = lazy(() => import('./components/connectors/wix/newconnection'));
const WixConnectionList = lazy(() => import('./components/connectors/wix'));
const AddSMTPAddress = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/emailconfiguration/addsmtp'));
const ShopifyStoreCheck = lazy(() => import('./components/connectors/shopify/storeCheck'));
const WhatsAppWebView = lazy(() => import('../src/whatsappWebView/index'));
const Wix3ds = lazy(() => import('../src/whatsappWebView/wix3dx'));
const WhatsAppPaymentWebView = lazy(() => import('../src/whatsappWebView/payments'));
const AiBotAnalytics = lazy(() => import('./components/main_layout/navigation/Analytics/widgets/aibotanalytics'));
const DynamicsConnectionList = lazy(() => import('./components/connectors/dynamics/connectionlist'));
const ConnectorsMain1 = lazy(() => import('./components/connectors/indexNew'));
const CustomerType = lazy(() => import('./newpages/Customertype/customertype'));
const VisitorInsights = lazy(() => import('./components/reports/visitorinsights'));
const ScheduledReports = lazy(() => import('./components/reports/scheduledreports'));
const QueueAnalytics = lazy(() => import('./components/main_layout/navigation/Analytics/widgets/queueanalytics'));
const WhatsappWebcallback = lazy(() => import('./whatsappcallback'));
const CsatEmailComponent = lazy(() => import('./components/main_layout/navigation/settings/general_settings/customer_satisfaction/csatEmailComponent'));
const FacebookWebcallback = lazy(() => import('./facebookcallback'));
const InstagramWebcallback = lazy(() => import("./instagramcallback"));
const UnsubscribeEmail = lazy(() => import("./unsubscribe"));
const MyActivity = lazy(() => import('./myactivity'));
const VideoCall = lazy(() => import('./components/main_layout/navigation/settings/basic_configuration/video_call'));
const RecordingViews = lazy(() => import('./components/recordingScreen/recordingview'));
const RecordingMainScreen = lazy(() => import('./components/recordingScreen'));
const AudioView = lazy(() => import('./components/recordingScreen/audioView'));
const CustomReports = lazy(() => import('./components/reports/customreports'));
const Createcustomreport = lazy(() => import('./components/reports/customreports/createcustomreport'));
const Conversationtrigger = lazy(() => import('./newpages/conversationtrigger/conversationtrigger'));
const Callblast = lazy(() => import("./callblast/callblast"));
// const PredictiveDialler = lazy(() => import("./predictivedialler/callblast"));
const Personalindextab = lazy(() => import("./callblast/personalindextab"));
const BroadCast = lazy(() => import("./components/cochat/broadcast"));
// const PredictivediallerPersonalindextab = lazy(() => import("./predictivedialler/personalindextab"));
const Interactionoverview = lazy(() => import('./components/webChatScreen/viewinteractionaccord'));
const CampaignReports = lazy(() => import('./components/reports/campaignreports/camreports'));
const AgentParticularReport = lazy(() => import('./components/reports/agentstsreport/index'));
const Viewparticularhistory = lazy(() => import('./callblast/particularhistory'));
const KnowledgeBaseMain = lazy(() => import('./components/knowledgebasenew/knwoledgebasemain'));
const KnowledgebaseMainInner = lazy(() => import('./components/knowledgebasenew/knowledgebaseinner'));


Chart.register(...registerables);
function App() {
  const [searchParams] = useSearchParams();
  const Draggable1: any = Draggable;
  const roomData: any = store.getState().chatReducer;
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const { unregister, makeCallFunctionForAll } = CallService(dispatch, navigate);
  const callLoginUserAgent: any = useSelector((state: any) => state.callLoginUserAgent);
  const [mount, setMount] = useState<boolean>(false);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { isSuccess } = callLoginUserAgent;
  let { videoacceptCallRoom, acceptCallRoom, isTrackAgent, isCallBackWaiting, callBackDetails, callBackTimer } = popUpDetails;
  const socialmediaWidget: any = useSelector((state: any) => state.socialmediaWidget);
  const { socialmediaInvite, } = socialmediaWidget
  const sharingReducerState: any = useSelector((state: any) => state.sharingReducerState);
  const { createCallConnection } = CallService(dispatch, navigate);
  const contactList: any = useSelector((state: any) => state.contactListForAgent);
  const { isGetAlluser, isGetAllTags, isDisposition, isQueueList, dispositionTagList } = contactList;
  const chatReducer: any = useSelector((state: any) => state.chatReducer);
  const newEmailEntry: any = useSelector((state: any) => state.newEntryEmailData.isNewEmailEntry);
  const meetingReducer: any = useSelector((state: any) => state.meetingReducer)
  const {activeParticipantList}=meetingReducer;
  const verificationReducer: any = useSelector((state: any) => state.verificationReducer);
  const {verifyModalEnable } = verificationReducer;
  const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
  const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const [servicePlanData, setServicePlanData] = useState<any>({})
  const [closeEmailVerify, setCloseEmailVerify] = useState<any>(true);
  let { supervisorWhisperStatus, currentSession } = store.getState().chatReducer;
  const { sharingStatus, annotationEnable, remoteVideoSize } = store.getState().sharingReducerState;
  const domainId = LoginCcaasUserDetails?.domainId;
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  const { isGetAllcontacts, allContactList } = useSelector((state: any) => state.contactListForAgent)
  const servicePlan = (companyId: any) => {
    let data = { "company_id": companyId }
    axios.post(`${config().MYACCOUNTSERVICE_URL}/billing/getBillServicePlan`, data).then((res: any) => {
      if (res?.data?.result.length > 0) {
        dispatch(ChatActions.servicePlan(res?.data?.result[0]))
        setServicePlanData(res?.data?.result[0])
      }
    }).catch((err: any) => {
      console.log(err)
    });
  }
  // if (process.env.REACT_APP_ENV === 'production') {
  //   console.log = () => {};
  // }

  useEffect(() => {
    if (accessToken) {
      ringer();
      getUserDetails();
    }
  }, [])

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      event.returnValue = true;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (accessToken) {
      let timeout: any;
      let lastMouseMove = 0;
      const TIME_FOR_INACTIVITY: number = 15 * 60 * 1000;
      const updatePresence = () => {
        callChatService.io.emit('update_inactivity_presence', true);
      };

      const markInactive = () => {
        SetItemInStorage("INACTIVE", true);
      };

      const markActive = () => {
        const isInactive = GetItemFromStorage("INACTIVE");
        if (isInactive === true) {
          SetItemInStorage("INACTIVE", false);
          callChatService.io.emit('update_inactivity_presence', false);
        }
      };

      const resetInactivityTimer = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          markInactive();
          updatePresence();
        }, TIME_FOR_INACTIVITY);
      };

      const handleActivity = () => {
        if (!document.hidden) {
          const now = Date.now();
          if (now - lastMouseMove > 2000) {
            lastMouseMove = now;
            markActive();
            resetInactivityTimer();
          }
        }
      };

      const handleVisibilityChange = () => {
        if (document.hidden) {
          resetInactivityTimer();
        } else {
          clearTimeout(timeout);
          resetInactivityTimer();
        }
      };

      const events = ["mousemove", "keydown", "scroll", "click"];
      events.forEach((e) => window.addEventListener(e, handleActivity));
      document.addEventListener("visibilitychange", handleVisibilityChange);
      resetInactivityTimer();

      return () => {
        events.forEach((e) => window.removeEventListener(e, handleActivity));
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        clearTimeout(timeout);
      };
    } else {
      const ringer = document.getElementById("ringer") as HTMLAudioElement | null;
      try {
        if (ringer && typeof ringer.pause === "function") {
          ringer.pause();
        } else {
          console.warn("Ringer element not found or not an audio element.");
        }
      } catch (error) {
        console.error("Failed to pause ringer:", error);
      }
    }
  }, [accessToken]);

  const ringer = () => {
    const audio = document.getElementById("ringer") as HTMLAudioElement;
    audio.src = process.env.PUBLIC_URL + "/ringtone/ringback--linux.mp3";
    audio.load(); // This re-evaluates the <source> children
  };

  const getUserDetails = async () => {
    try {
      const response = await CoreServices.get(`/get_user_details_email`)
      if (response?.data.statusCode === 200 && Array.isArray(response?.data.getUserDetailsRes) && response?.data.getUserDetailsRes.length > 0) {
        dispatch(outboundCampaignSliceAction.setUserCallInfo(response?.data?.getUserDetailsRes?.[0]?.outboundCampaignCall ?? 0))
      }
    } catch (error) {
      console.log("getUserDetails", error)
    }
  }

  useEffect(() => {
    if (!isSuccess && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/" && !window.location.pathname.includes("/customervideochat")) {
      createCallConnection();
    }
    // if (!isGetAlluser && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/") {
    //   !isGetAllcontacts && allContactList && dispatch(getAllContactList());
    // }
    if (!isGetAllTags && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/") {
      dispatch(getTagsForCustomers());
    }
    if ((!isDisposition || !dispositionTagList?.length) && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/") {
      dispatch(getDispositionForCustomers());
    }
    if (!isQueueList && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/") {
      dispatch(getQueueeList());
    }
    if (!chatReducer.isSocketJoin && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/") {
      new callChatService(accessToken, navigate, dispatch);
      new presenceService(accessToken, navigate, dispatch, 0);
      ringer();

    }
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    dispatch(
      LoginActions.login({
        token: '',
        loginUserDetails: userDetails,
      })
    );
    userDetails?.companyId && !["/dynamicdashboard", "/dashboard"].includes(window?.location?.pathname) && servicePlan(userDetails?.companyId);
  }, [dispatch, !PublicRoutes.has(window?.location?.pathname)]);

  useEffect(() => {
    if ((!PublicRoutes.has(window?.location?.pathname) || !window.location.pathname.includes("customervideochat")) && accessToken) {
      console.log("CURRENT STATE OF USER IS CHANGED TO A NEW VALUE FROM API");
      accessToken && dispatch(getAllUsers());
      accessToken && dispatch(updateAgentState());
    }
  }, [!PublicRoutes.has(window?.location?.pathname), accessToken]);

  const callBackHandle = (accepted: boolean) => {
    if (accepted) {
      callChatService.callBackReject({ ...callBackDetails, status: 'success' });
      makeCallFunctionForAll(callBackDetails.callbackDid, '2', '');
      sessionStorage.setItem("callback", "1");
      sessionStorage.setItem("yescallback", "1");
      sessionStorage.setItem('callBackHistoryId', JSON.stringify(callBackDetails?.session_id))
    } else {
      callChatService.callBackReject({ ...callBackDetails, status: 'rejected' });
      callChatService.callDashboard(domainId)
      const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      const LoginUserDetails: any = userDetails;
      const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      const { users } = store.getState().userList;
      let enableStatus: any = null
      if (users.length > 0) {
        [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
      }
      console.log('presenceService 17');
      presenceService?.io?.emit("updatestate_backend", {
        domainId: LoginUserDetails?.domainId,
        isVoice: 0,
        isVoiceCallTransfer: 0,
        isChat: 0,
        isChatTransfer: 0,
        isEmail: 0,
        isEmailTransfer: 0,
        stateTime: Math.floor(Date.now() / 1000),
        statusName: 'Not Ready',
        ext: LoginUserDetails?.ext,
        email: LoginUserDetails?.Email,
        userId: LoginUserDetails?.UserID,
        routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
        userName: LoginCcaasUserDetails?.UserName,
        roleId: LoginCcaasUserDetails?.roleid,
        agentStatus: 0,
        skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
        routingMethod: enableStatus?.routingMethod ?? 0,
        inboundCall: enableStatus?.inboundCall,
        outboundCampaignCall: enableStatus?.outboundCampaignCall,
        is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
      });
    }
    let data: any = {
      isCallBackWaiting: false,
      callBackDetails: {},
      callBackTimer: accepted ? null : 1,
      reject: true
    };
    dispatch(CallPopUpAgentActions.setCallBackInfo(data));
  };

  const onUnload = async (e: any) => {
    let { currdeviceinfo }: any = store.getState().meetingReducer;
    const meetingDetails: any = store.getState().meetingReducer;
    let { recordTranscript, recordId }: any = store.getState().closeCaption;
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('createConnection');
    if (currdeviceinfo.recordingStatus !== "stop" && Array.isArray(recordTranscript) && recordTranscript?.length > 0) {
      let data: any = {};
      data.recordId = recordId;
      data.domain_id = meetingDetails.meetingDetails.agentDetails.domain_id;
      data.recordTranscript = recordTranscript;
      await MeetServices.post(data, `insert_videomeet_record_transcript`).then((response: any) => {
        if (response?.data?.statusCode === 200) {
          console.log("inserted successfully========")
        }
      }
      )
        .catch((err: any) => {
          console.log("insert rec transcript", err);
        })
    }
    videoCallService.refreshClosetab();
    updateVirtualBGRedux("", 0);
    return true;
  };

  useEffect(() => {
    if (!mount) {
      window.addEventListener("beforeunload", onUnload);
      setMount(true);

    }
  }, [JSON.stringify(sharingReducerState), remoteVideoSize, sharingStatus, annotationEnable, JSON.stringify(meetingReducer), mount])

  useEffect(() => {
    if (LoginCcaasUserDetails === null) {
      const shopifyStore: any = searchParams.get('shopifyData');
      const bigCommerceStore: any = searchParams.get('signed_payload');
      const bigCommerceStoreSource: any = searchParams.get('source');
      const wixStore: any = searchParams.get('wix_code');

      if (shopifyStore !== null) {
        sessionStorage.setItem(LocalStorage.SHOPIFY_CRED, shopifyStore);
      }
      if (bigCommerceStore && bigCommerceStoreSource) {
        sessionStorage.setItem(LocalStorage.BIGCOMMERCE_CRED, bigCommerceStore);
        sessionStorage.setItem(LocalStorage.BIGCOMMERCE_SOURCE, bigCommerceStoreSource);
      }
      if (wixStore) {
        sessionStorage.setItem(LocalStorage.WIX_CRED, wixStore);
      }
    }
  }, [])
  useEffect(() => {
    if (!roomData.isIncomingChat && roomData?.additionalChatRequest?.length > 0) {
      const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      let message = { ...roomData?.additionalChatRequest[0] };
      if (message.agentId === `${userDetails?.domainId}_${userDetails?.ext}`) {
        setTimeout(() => {
          dispatch(
            getNecessaryDetails({
              contact: message?.sender["coid"],
              sessionId: message?.userId.trim(),
            })
          ).unwrap()
            .then((response: any) => {
              if (response?.contact?.data?.statusCode === 200) {
                message["contactDetails"] =
                  response.contact.data.getContactDetailsRes.length > 0
                    ? response.contact.data.getContactDetailsRes[0]
                    : {};
              } else {
                message["contactDetails"] = {};
              }

              if (response?.sessionDetail?.data?.statusCode === 200) {
                console.log(
                  "response?.sessionDetail?.data?.statusCode",
                  response?.sessionDetail?.data
                );
                message["queueName"] =
                  response.sessionDetail.data.getSessionDetailsRes.length > 0
                    ? response.sessionDetail.data.getSessionDetailsRes[0]
                      .queueName
                    : "";
              } else {
                message["queueName"] = "";
              }

              dispatch(ChatActions.incomingChat(message));
              let ringer: any = document.getElementById("ringer");
              if (ringer) {
                // if (document.hasFocus()) {
                ringer?.play();
                ringer.muted = false;
                // } else {
                //   const ans = window.confirm(
                //     "Do you want to enable chat ringtone?"
                //   );
                //   if (ans) {
                //     ringer?.play();
                //     ringer.muted = false;
                //   }
                // }
              }

              if ("Notification" in window) {
                Notification.requestPermission().then((permission) => {
                  if (permission === "granted") {
                    var notificationBrowser = new Notification(
                      "CCAAS-Worktual",
                      {
                        body: `Chat From ${message.contactDetails?.firstName !== ""
                          ? message.contactDetails?.firstName
                          : message.sender["Phone Number"]
                          } in worktual contact center`,
                        icon: "",
                      }
                    );
                    notificationBrowser.onclick = function (event) {
                      event.preventDefault();
                      window.parent.focus();
                      notificationBrowser.close();
                    };
                  }
                });
              }
            });
        }, 10000)
      }
      const resultData = roomData?.additionalChatRequest.slice(1);
      dispatch(ChatActions?.setAdditionChatReplaceData(resultData));
    }
  }, [roomData.isIncomingChat])


  useEffect(() => {
    fetchDevices()
    const title :any =  getDynamicTitle();
    document.title = title;
  }, []);

  useEffect(() => {
    navigator?.mediaDevices?.addEventListener("devicechange", fetchDevices);
    return () => {
      navigator.mediaDevices.removeEventListener("devicechange", fetchDevices);
    };
  }, []);

  const fetchDevices = async () => {
    try {
      console.log('mic changes')
      handleDeviceChange()
      /*       let remoteVideo: any = document.getElementById("remoteVideo");
            if (!remoteVideo) {
              console.error('Audio element not found');
              return;
            }
            if (remoteVideo.setSinkId) {
              await remoteVideo.setSinkId('default');
            } else {
              console.error('setSinkId is not supported in this browser.');
            } */
    } catch (err) {
      console.error('Error enumerating devices:', err);
    }
  };

  const handleDeviceChange = async () => {
    try {
      const micPermission = await navigator.permissions.query({ name: "microphone" as PermissionName });

      if (micPermission.state === "denied") {
        console.warn("❌ Microphone access denied. Show user how to fix it.");
        alert(
          `Microphone access is blocked.\n\nPlease enable it manually:\n1. Click the 🔒 lock icon in the address bar\n2. Choose "Site settings"\n3. Set Microphone to "Allow"\n4. Refresh the page.\n\nOr open this in a new tab:\nchrome://settings/content/siteDetails?site=${window.location.origin}`
        );
      } else if (micPermission.state === "prompt") {
        console.log("Requesting microphone permission...");
        try {
          await navigator.mediaDevices.getUserMedia({ audio: true });
          console.log("✅ Microphone access granted.");
        } catch (err) {
          console.error("User denied microphone access:", err);
        }
      } else if (micPermission.state === "granted") {
        console.log("✅ Microphone access already granted.");
      }

    } catch (err) {
      console.error("Error checking microphone permission:", err);
    }
  };

  const isMobile = useMediaQuery({ maxWidth: 1024 });


  // useEffect(() => {
  //   if(currentSession?.channeltype === "Call" && isMobile){


  //   if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  //     navigator.mediaDevices.getUserMedia({ audio: true })
  //         .then(function(stream) {
  //             console.log('Microphone access granted');
  //         })
  //         .catch(function(error) {
  //             console.log('Microphone access denied or error occurred: ', error);
  //         });
  // } else {
  //     console.log('This browser does not support microphone access.');
  // }}}, [currentSession, isMobile])

  return (
    <>
      {(['view', 'whisper', 'barge'].includes(supervisorWhisperStatus) && (LoginCcaasUserDetails?.roleid == 5 || LoginCcaasUserDetails?.roleid == 3)) ? <SupervisorWhisperStatus /> : ''}

      <div className={(['view', 'whisper', 'barge'].includes(supervisorWhisperStatus) && (LoginCcaasUserDetails?.roleid == 5 || LoginCcaasUserDetails?.roleid == 3)) ? 'whisperapp' : ''}>
        <div className={`App ${(closeEmailVerify && roleId == ROLES.ADMIN_ROLE_ID && servicePlanData.Is_free_trail === 1 && servicePlanData?.freetrail_rem_days === 0) ? `emailverify` : ''}`}>
          {(!["/login", '/whatsappwebview', '/WhatsAppWebView', '/whatsapppaymentwebview', '/wix3ds'].includes(window.location.pathname) && closeEmailVerify && roleId == ROLES.ADMIN_ROLE_ID && servicePlanData.Is_free_trail === 1 && servicePlanData?.freetrail_rem_days <= 0) &&
            <div className="verificationtag">
              {/* <p>Email verification pending. Kindly verify your email. <b onClick={sendEmailVerification}>Verify Now</b></p> */}
              <p><span>👋</span> Your trial is over, <b onClick={() => {
                window.open(
                  "https://myaccount.worktual.co.uk/purchasemain",
                  "_blank"
                );
              }}>upgrade </b> the plan to continue using the product</p>
              {/* <span className="icon_close" onClick={() => setCloseEmailVerify(false)}></span> */}
            </div>
          }
          {window.location.pathname !== "/login" && !window.location.pathname.includes('/customervideochat') && accessToken && window.location.pathname !== "/" && <ShortCutKeys />}
          {acceptCallRoom && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/" && (
            <Draggable1>
              <div className={styles.agentTransfer}>
                <IncomingCallNotify />
              </div>
            </Draggable1>
          )}
          {videoacceptCallRoom && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/" && (
            <Draggable1>
              <div className={styles.agentTransfer}>
                <IncomingVideoCallNotify />
              </div>
            </Draggable1>
          )}
          {roomData.isIncomingChat && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/" && (
            <Draggable1>
              <div className={styles.agentTransfer}>
                <IncomingChatNotify />
              </div>
            </Draggable1>
          )}
          {newEmailEntry && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/" && (
            <Draggable1>
              <div className={styles.agentTransfer}>
                <IncomingEmailNotify />
              </div>
            </Draggable1>
          )}
          {socialmediaInvite && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/" && (
            <Draggable1>
              <div className={styles.agentTransfer}>
                <SocialmediaWidget />
              </div>
            </Draggable1>
          )}

 {(verifyModalEnable) &&  activeParticipantList.length > 1 &&<Verificationmodal />}

          {window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/" && (
            <Modal title={<><span>Auto-Call back Confirmation</span> <label className="timeclrtop">{callBackTimer}</label></>}
              centered className="customModal sizessmall autocallmodal" open={isCallBackWaiting}
              // closeIcon={<span className="icon__Close16"> </span>}
              footer={[
                <Button className="buttonCancel"
                  onClick={() => callBackHandle(false)}
                >
                  No
                </Button>,
                <Button type="primary" className="buttonSave "
                  onClick={() => callBackHandle(true)}
                >
                  Yes
                </Button>,
              ]}>
              <p>Queue Name - {callBackDetails?.queue_name ?? ""}</p>

              <p>{callBackDetails?.firstname ? callBackDetails?.firstname?.trim() !== "" ? `${callBackDetails?.first_name} ${callBackDetails?.last_name}` : "New Customer" : "New Customer"}  - {callBackDetails?.callbackDid}</p>

              <p>Are you sure you want to initiate an automatic call back?</p>
            </Modal>)}
          {isTrackAgent && window.location.pathname !== "/login" && accessToken && window.location.pathname !== "/" && <CallWhisper />}
          {/* <OncallPad /> */}
          <Suspense fallback={null}>
            <Routes>

              <Route element={<ControlledRoutes navigate={navigate} dispatch={dispatch} />}>
                <Route element={((!sharingStatus && !meetingReducer.fullScreenAgent)) ? <MainLayout /> : <AgentFullScreen />}>

                  <Route element={<Suspense fallback={<Loaders />}><ChatBot /></Suspense>} path="/chatbot" />
                  <Route element={<Suspense fallback={<Loaders />}><ChatFlow /></Suspense>} path="/chatflow" />
                  <Route element={<Suspense fallback={<Loaders />}><ChatFlowList /></Suspense>} path="/chatflowlist" />
                  <Route element={<Suspense fallback={<Loaders />}><ChatLimit /></Suspense>} path="/chatlimit" />
                  <Route element={<Suspense fallback={<Loaders />}><PrivateApp /></Suspense>} path="/privateapp" />
                  <Route element={<Suspense fallback={<Loaders />}><OauthAppList /></Suspense>} path="/publicapp" />
                  <Route element={<Suspense fallback={<Loaders />}><EmailChannelNew /></Suspense>} path="/emailchannellist" />
                  <Route element={<Suspense fallback={<Loaders />}><EmailConfig /></Suspense>} path="/emailconfig" />
                  <Route element={<Suspense fallback={<Loaders />}><UserManagemantList /></Suspense>} path="/usermanagement" />
                  <Route element={<Suspense fallback={<Loaders />}><Usermanagement /></Suspense>} path="/usermanagement/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><SkillManagement /></Suspense>} path="/skillmanagement" />
                  <Route element={<Suspense fallback={<Loaders />}><CallFlow /></Suspense>} path="/callFlowView" />
                  <Route element={<Suspense fallback={<Loaders />}><CallFlowTableList /></Suspense>} path="/callFlow" />
                  <Route element={<Suspense fallback={<Loaders />}><ContactCenterNumber /></Suspense>} path="/contactcenternumber" />
                  <Route element={<Suspense fallback={<Loaders />}><MyActivity /></Suspense>} path="/allactivity" />
                  <Route element={<Suspense fallback={<Loaders />}><MyActivity /></Suspense>} path="/myactivity" />
                  <Route element={<Suspense fallback={<Loaders />}><AnsweredCallReports /></Suspense>} path="/answeredcallreport" />
                  <Route element={<Suspense fallback={<Loaders />}><ChatsReport /></Suspense>} path="/chatsreport" />
                  <Route element={<Suspense fallback={<Loaders />}><WebChatAgentChatReport /></Suspense>} path="/webchatagentchatreport" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentRouting /></Suspense>} path="/routingprofile/create" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentRouting /></Suspense>} path="/routingprofile/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><QueueList /></Suspense>} path="/customqueue/list" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateCustomQueue /></Suspense>} path="/customqueue" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateCustomQueue /></Suspense>} path="/customqueue/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><RoutingProfile /></Suspense>} path="/routingprofile" />
                  <Route element={<Suspense fallback={<Loaders />}><SmsListNumber /></Suspense>} path="/smsListTable" />
                  <Route element={<Suspense fallback={<Loaders />}><PlayPromtNew /></Suspense>} path="/playprompt" />
                  <Route element={<Suspense fallback={<Loaders />}><BusinessHours /></Suspense>} path="/businesshours/list" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateBusinessHours /></Suspense>} path="/businesshours/create" />
                  <Route element={<Suspense fallback={<Loaders />}><WebChatMain /></Suspense>} path="/conversation/webchat" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateBusinessHours /></Suspense>} path="/BusinessHours/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><ViewBusinessHours /></Suspense>} path="/BusinessHours/view" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateWebChatWidget /></Suspense>} path="/webchatwidget/configuration" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateWebChatWidget /></Suspense>} path="/webchatwidgetedit/configuration" />
                  <Route element={<Suspense fallback={<Loaders />}><WebChatList /></Suspense>} path="/webchatwidget/list" />
                  <Route element={<Suspense fallback={<Loaders />}><CallConfig /></Suspense>} path="/callconfig" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateCall /></Suspense>} path="/callconfig/create" />
                  <Route element={<Suspense fallback={<Loaders />}><EditCall /></Suspense>} path="/callconfig/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><DispositionStatusList /></Suspense>} path="dispositionstatus" />
                  <Route element={<Suspense fallback={<Loaders />}><DispositionStatusDetails /></Suspense>} path="dispositiondetails" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusList /></Suspense>} path="agentstatus" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusDetails /></Suspense>} path="agentdetails/create" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusDetails /></Suspense>} path="agentstatus/agentdetails/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusDetailsView /></Suspense>} path="agentstatus/agentdetails/view" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusDetails /></Suspense>} path="agentdetails" />
                  <Route element={<Suspense fallback={<Loaders />}><CustomerTag /></Suspense>} path="customertag" />
                  <Route element={<Suspense fallback={<Loaders />}><CustomerType /></Suspense>} path="customertype" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorTableList /></Suspense>} path="/supervisorviewcontact" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorProfileContact /></Suspense>} path="/supervisorprofilecontact" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorBlock /></Suspense>} path="/supervisor/Blockcontact" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorDND /></Suspense>} path="/supervisor/DNDcontact" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorProfileForm /></Suspense>} path="/supervisor/createcontact" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorLeftUser /></Suspense>} path="/BlockedContactsList" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorDNDview /></Suspense>} path="/DNDContactList" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorLeftUser /></Suspense>} path="/BlockRequestDetails" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorDNDview /></Suspense>} path="/DNDRequestDetails" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorProfileContact /></Suspense>} path="/supervisorprofilecontact/display" />
                  <Route element={<Suspense fallback={<Loaders />}><CallFlow /></Suspense>} path="/callFlowView" />
                  <Route element={<Suspense fallback={<Loaders />}><CallFlowTableList /></Suspense>} path="/callFlow" />
                  <Route element={<Suspense fallback={<Loaders />}><CallFlow /></Suspense>} path="/callFlowView" />
                  <Route element={<Suspense fallback={<Loaders />}><CallFlowTableList /></Suspense>} path="/callFlow" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentRouting /></Suspense>} path="/routingprofile/create" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentRouting /></Suspense>} path="/routingprofile/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><QueueList /></Suspense>} path="/customqueue/list" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateCustomQueue /></Suspense>} path="/customqueue" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateCustomQueue /></Suspense>} path="/customqueue/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><RoutingProfile /></Suspense>} path="/routingprofile" />
                  <Route element={<Suspense fallback={<Loaders />}><SmsListNumber /></Suspense>} path="/smsListTable" />
                  <Route element={<Suspense fallback={<Loaders />}><AddWorktualSupportAddress /></Suspense>} path="/addworktualsupportaddress" />
                  <Route element={<Suspense fallback={<Loaders />}><AddSMTPAddress /></Suspense>} path="/addsmtpaddress" />
                  <Route element={<Suspense fallback={<Loaders />}><PlayPromtNew /></Suspense>} path="/playprompt" />
                  <Route element={<Suspense fallback={<Loaders />}><BusinessHours /></Suspense>} path="/businesshours/list" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateBusinessHours /></Suspense>} path="/businesshours/create" />
                  <Route element={<Suspense fallback={<Loaders />}><WebChatMain /></Suspense>} path="/conversation/webchat" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateBusinessHours /></Suspense>} path="/BusinessHours/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><ViewBusinessHours /></Suspense>} path="/BusinessHours/view" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateWebChatWidget /></Suspense>} path="/webchatwidget/configuration" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateWebChatWidget /></Suspense>} path="/webchatwidgetedit/configuration" />
                  <Route element={<Suspense fallback={<Loaders />}><WebChatList /></Suspense>} path="/webchatwidget/list" />
                  <Route element={<Suspense fallback={<Loaders />}><DispositionStatusList /></Suspense>} path="dispositionstatus" />
                  <Route element={<Suspense fallback={<Loaders />}><DispositionStatusDetails /></Suspense>} path="dispositiondetails" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusList /></Suspense>} path="agentstatus" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusDetails /></Suspense>} path="agentdetails/create" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusDetails /></Suspense>} path="agentstatus/agentdetails/edit" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusDetailsView /></Suspense>} path="agentstatus/agentdetails/view" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentStatusDetails /></Suspense>} path="agentdetails" />
                  <Route element={<Suspense fallback={<Loaders />}><CustomerTag /></Suspense>} path="customertag" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorBlock /></Suspense>} path="/supervisor/Blockcontact" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorDND /></Suspense>} path="/supervisor/DNDcontact" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorProfileForm /></Suspense>} path="/supervisor/createcontact" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorLeftUser /></Suspense>} path="/BlockedContactsList" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorDNDview /></Suspense>} path="/DNDContactList" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorLeftUser /></Suspense>} path="/BlockRequestDetails" />
                  <Route element={<Suspense fallback={<Loaders />}><SupervisorDNDview /></Suspense>} path="/DNDRequestDetails" />
                  <Route element={<Suspense fallback={<Loaders />}><WebSiteURL /></Suspense>} path="/websiteurl" />
                  <Route element={<Suspense fallback={<Loaders />}><ActivityInfo /></Suspense>} path="/ContactActivity" />
                  <Route element={<Suspense fallback={<Loaders />}><AllActivityMain /></Suspense>} path="/conversation/allactivity" />
                  <Route element={<Suspense fallback={<Loaders />}><Analytics /></Suspense>} path="/analytics" />
                  <Route element={<Suspense fallback={<Loaders />}><CoChat /></Suspense>} path="/internalchat" />
                  <Route element={<Suspense fallback={<Loaders />}><ShortcutKeys /></Suspense>} path="/shortcutkeys" />
                  <Route element={<Suspense fallback={<Loaders />}><WebSiteURL /></Suspense>} path="/websiteurl" />
                  <Route element={<Suspense fallback={<Loaders />}><AddsupportSupport /></Suspense>} path="/addsupport" />
                  <Route element={<Suspense fallback={<Loaders />}><SuspendedEmails /></Suspense>} path="/suspendedemails" />
                  <Route element={<Suspense fallback={<Loaders />}><VerifySupportAddress /></Suspense>} path="/verifysupportaddress" />
                  <Route element={<Suspense fallback={<Loaders />}><VerifyWorktualSupportAddress /></Suspense>} path="/verifyworktualsupportaddress" />
                  <Route element={<Suspense fallback={<Loaders />}><WebChatScreen /></Suspense>} path="/chatscreenagent" />
                  <Route element={<Suspense fallback={<Loaders />}><Dynamicdashindexanimated/></Suspense>} path="/dynamicdashboard" />
                  <Route element={<Suspense fallback={<Loaders />}><AdminDashboard /></Suspense>} path="/dashboard" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentDashboard /></Suspense>} path="/agentdashboard" />
                  <Route element={<Suspense fallback={<Loaders />}><DashboardReport /></Suspense>} path="/dashboardreport" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentDashboardReport /></Suspense>} path="/agentdashboardreport" />
                  {/* <Route element={<ConnectorsMain />} path="/connectors" /> */}
                  <Route element={<Suspense fallback={<Loaders />}><ConnectorsMain1 /></Suspense>} path="/connectors" />
                  <Route element={<Suspense fallback={<Loaders />}><ConnectorsInner /></Suspense>} path="/connectorsinner" />
                  <Route element={<Suspense fallback={<Loaders />}><ContactConnector /></Suspense>} path="/contactconnector" />
                  <Route element={<Suspense fallback={<Loaders />}><ContactForm /></Suspense>} path="/contactform" />
                  <Route element={<Suspense fallback={<Loaders />}><ConnectorSubModule /></Suspense>} path="/submodule" />
                  <Route element={<Suspense fallback={<Loaders />}><ApiIntegration /></Suspense>} path="/apiintegration" />
                  <Route element={<Suspense fallback={<Loaders />}><CreateApi /></Suspense>} path="/createapi" />
                  <Route element={<Suspense fallback={<Loaders />}><ApiInner /></Suspense>} path="/apiinner" />
                  <Route element={<Suspense fallback={<Loaders />}><APIConfiguration /></Suspense>} path="/apiconfiguration" />
                  <Route element={<Suspense fallback={<Loaders />}><ApiContactSync /></Suspense>} path="/apicontactsync" />
                  <Route element={<Suspense fallback={<Loaders />}><OauthClient /></Suspense>} path="/oauthclient" />
                  <Route element={<Suspense fallback={<Loaders />}><AddClient /></Suspense>} path="/addclient" />
                  <Route element={<Suspense fallback={<Loaders />}><EditClient /></Suspense>} path="/editclient" />
                  <Route element={<Suspense fallback={<Loaders />}><EndpointDetails /></Suspense>} path="/endpointdetails" />
                  <Route element={<Suspense fallback={<Loaders />}><ChannelConfigMain /></Suspense>} path="/channelconfiguration" />
                  <Route element={<Suspense fallback={<Loaders />}><UpdatewhatsappAcc /></Suspense>} path="/updatewhatsapp" />
                  <Route element={<Suspense fallback={<Loaders />}><ChannelReportsMain /></Suspense>} path="/channelreports" />
                  <Route element={<Suspense fallback={<Loaders />}><SmsUpdate /></Suspense>} path="/smsupdate" />
                  <Route element={<Suspense fallback={<Loaders />}><KnowledgeBaseMain /></Suspense>} path="/knowledgebasemain" />
                  <Route element={<Suspense fallback={<Loaders />}><KnowledgebaseMainInner /></Suspense>} path="/knowledgebasemain/:knowledgeBaseType" />
                  <Route element={<Suspense fallback={<Loaders />}><KnowledgeBase /></Suspense>} path="/knowledgebase" />
                  <Route element={<Suspense fallback={<Loaders />}><KnowledgebaseInner /></Suspense>} path="/knowledgebaseinner" />
                  <Route element={<Suspense fallback={<Loaders />}><KnowledgebaseEdit /></Suspense>} path="/knowledgebaseedit" />
                  <Route element={<Suspense fallback={<Loaders />}><SettingsMain /></Suspense>} path="/settingspage" />
                  {/* <Route element={<Tablecom />} path="/settingspage" /> */}
                  <Route element={<Suspense fallback={<Loaders />}><ContactScreen /></Suspense>} path="/contactscreen" />
                  <Route element={<Suspense fallback={<Loaders />}><ContactDetailsScreen /></Suspense>} path="/contactsdetail" />
                  <Route element={<Suspense fallback={<Loaders />}><AttachmentDetails /></Suspense>} path="/attachmentDetails" />
                  <Route element={<Suspense fallback={<Loaders />}><ManageDuplicate /></Suspense>} path="/manageduplicate" />
                  <Route element={<Suspense fallback={<Loaders />}><FlowScreen /></Suspense>} path="/flowscreen" />
                  <Route element={<Suspense fallback={<Loaders />}><StandAloneMain /></Suspense>} path="/standaloneDashboard" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentDashBoardKelvin /></Suspense>} path="/agentdashboardstandalone" />
                  <Route element={<Suspense fallback={<Loaders />}><QueueAnalytics /></Suspense>} path="/queueanalytics" />
                  <Route element={<Suspense fallback={<Loaders />}><ReportsMenuSidebar /></Suspense>} path="/reportsmain" />
                  <Route element={<Suspense fallback={<Loaders />}><Agentreportsmain /></Suspense>} path="/agentreports" />
                  <Route element={<Suspense fallback={<Loaders />}><LeadGenration /></Suspense>} path="/leadgenaration" />
                  <Route element={<Suspense fallback={<Loaders />}><Knowledgebaseupgrade /></Suspense>} path="/knowledgebaseupgrade" />
                  <Route element={<Suspense fallback={<Loaders />}><Customersatisfaction /></Suspense>} path="/customersatisfaction" />
                  <Route element={<Suspense fallback={<Loaders />}><CustomersatisfactionCreate /></Suspense>} path="/customersatisfaction/create" />
                  <Route element={<Suspense fallback={<Loaders />}><ConnectorList /></Suspense>} path="/connectorslist" />
                  <Route element={<Suspense fallback={<Loaders />}><ConnectorCompanyList /></Suspense>} path="/connectorscompanylist" />
                  <Route element={<Suspense fallback={<Loaders />}><AIBotreportsmain /></Suspense>} path="/aibotreports" />
                  <Route element={<Suspense fallback={<Loaders />}><ShopifyStoreCheck /></Suspense>} path="/shopifystorecheck" />
                  <Route element={<Suspense fallback={<Loaders />}><ShopifyNewConnection /></Suspense>} path="/shopifyconnection" />
                  <Route element={<Suspense fallback={<Loaders />}><ShopifyConnectionList /></Suspense>} path="/connectionlist" />
                  <Route element={<Suspense fallback={<Loaders />}><WixStoreCheck /></Suspense>} path="/wixstorecheck" />
                  <Route element={<Suspense fallback={<Loaders />}><BigcommerceConnectionList /></Suspense>} path="/bigcommerceconnectionlist" />
                  <Route element={<Suspense fallback={<Loaders />}><HubspotConnectors /></Suspense>} path="/hubspotconnectorlist" />
                  <Route element={<Suspense fallback={<Loaders />}><GoogleSheetConnection /></Suspense>} path="/googleSheetConnection" />
                  <Route element={<Suspense fallback={<Loaders />}><HubSpotConnection /></Suspense>} path="/hubspotconnection" />
                  <Route element={<Suspense fallback={<Loaders />}><WixConnection /></Suspense>} path="/wixapiconnection" />
                  <Route element={<Suspense fallback={<Loaders />}><WixConnectionList /></Suspense>} path="/wixconnectionlist" />
                  <Route element={<Suspense fallback={<Loaders />}><XeroConnectionList /></Suspense>} path="/xeroconnectionlist" />
                  <Route element={<Suspense fallback={<Loaders />}><Voicerecordings /></Suspense>} path="/recordSetting" />
                  <Route element={<Suspense fallback={<Loaders />}><PaymentMethods /></Suspense>} path="/paymentmethods" />
                  <Route element={<Suspense fallback={<Loaders />}><PayPal /></Suspense>} path="/paymentmethods/paypal" />
                  <Route element={<Suspense fallback={<Loaders />}><PayPalBraintree /></Suspense>} path="/paymentmethods/paypalbriantree" />
                  <Route element={<Suspense fallback={<Loaders />}><Stripe /></Suspense>} path="/paymentmethods/stripe" />
                  <Route element={<Suspense fallback={<Loaders />}><GlobalPayment /></Suspense>} path="/paymentmethods/globalpayment" />
                  <Route element={<Suspense fallback={<Loaders />}><Square /></Suspense>} path="/paymentmethods/square" />
                  <Route element={<Suspense fallback={<Loaders />}><Razorpay /></Suspense>} path="/paymentmethods/razorpay" />
                  <Route element={<Suspense fallback={<Loaders />}><MagentoConnectionList /></Suspense>} path="/magentolist" />
                  <Route element={<Suspense fallback={<Loaders />}><MagentoNewConnection /></Suspense>} path="/magentonewconnection" />
                  <Route element={<Suspense fallback={<Loaders />}><ZendeskSupportNewConnection /></Suspense>} path="/zendesksupport/new" />
                  <Route element={<Suspense fallback={<Loaders />}><ZendeskConnectionList /></Suspense>} path="/zendesksupport/list" />
                  <Route element={<Suspense fallback={<Loaders />}><NewConnection /></Suspense>} path="/woocommercenewconnection" />
                  <Route element={<Suspense fallback={<Loaders />}><WoocommerceList /></Suspense>} path="/woocommercelist" />
                  <Route element={<Suspense fallback={<Loaders />}><DynamicsConnectionList /></Suspense>} path="/dynamicsconnectionlist" />
                  <Route element={<Suspense fallback={<Loaders />}><RestrictedContact /></Suspense>} path="/restrictedcontacts" />
                  <Route element={<Suspense fallback={<Loaders />}><Skeleton /></Suspense>} path="/skeleton" />
                  {/* (Demo) For UI develeoper do u want to add route in this file , please add below */}
                  <Route element={<Suspense fallback={<Loaders />}><WhatsappDemo /></Suspense>} path="/whatsappconfig" />
                  <Route element={<Suspense fallback={<Loaders />}><ContactSettings /></Suspense>} path="/contactsettings" />
                  <Route element={<Suspense fallback={<Loaders />}><Facebook /></Suspense>} path="/facebookconfig" />
                  <Route element={<Suspense fallback={<Loaders />}><UpdatefacebookAcc /></Suspense>} path="/updatefacebook" />
                  <Route element={<Suspense fallback={<Loaders />}><Addfacebookacc /></Suspense>} path="/addfacebookacc" />
                  <Route element={<Suspense fallback={<Loaders />}><Instagram /></Suspense>} path="/instagramconfig" />
                  <Route element={<Suspense fallback={<Loaders />}><VideoCall /></Suspense>} path="/videoconfig" />
                  <Route element={<Suspense fallback={<Loaders />}><UpdateinstagramAcc /></Suspense>} path="/updateinstagram" />
                  <Route element={<Suspense fallback={<Loaders />}><AddInstagramacc /></Suspense>} path="/addinstagramacc" />
                  <Route element={<Suspense fallback={<Loaders />}><EmailTemplate /></Suspense>} path="/emailtemplate" />
                  <Route element={<Suspense fallback={<Loaders />}><Callblast /></Suspense>} path="/callblast" />
                  {/* <Route element={<Personalindextab />} path="/callblast" /> */}
                  {/* <Route element={<Suspense fallback={<Loaders />}><PredictiveDialler /></Suspense>} path="predictivedialler" /> */}
                  <Route element={<Suspense fallback={<Loaders />}><Personalindextab /></Suspense>} path="/createCallblast" />
                  {/* <Route element={<Suspense fallback={<Loaders />}><PredictivediallerPersonalindextab /></Suspense>} path="/createPredictivedialler" /> */}
                  <Route element={<Suspense fallback={<Loaders />}><EditorOne /></Suspense>} path="/editorone" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentanalyticsMain /></Suspense>} path="/agentanalyticsmain" />
                  <Route element={<Suspense fallback={<Loaders />}><AiBotAnalytics /></Suspense>} path="/aibotanalytics" />
                  <Route element={<Suspense fallback={<Loaders />}><VisitorInsights /></Suspense>} path="/visitorinsights" />
                  <Route element={<Suspense fallback={<Loaders />}><ScheduledReports /></Suspense>} path="/sheduledreports" />
                  <Route element={<Suspense fallback={<Loaders />}><CustomReports /></Suspense>} path="/customreports" />
                  <Route element={<Suspense fallback={<Loaders />}><Createcustomreport /></Suspense>} path="/createcustomreports" />
                  <Route element={<Suspense fallback={<Loaders />}><RecordingViews /></Suspense>} path='/recordings' />
                  <Route element={<Suspense fallback={<Loaders />}><AudioView /></Suspense>} path='/audiorecordings' />
                  <Route element={<Suspense fallback={<Loaders />}><RecordingMainScreen /></Suspense>} path='/recordingscreen' />
                  <Route element={<Suspense fallback={<Loaders />}><Createcustomreport /></Suspense>} path="/customreports/createcustomreports" />
                  <Route element={<Suspense fallback={<Loaders />}><Conversationtrigger /></Suspense>} path="/conversationtrigger" />
                  <Route element={<Suspense fallback={<Loaders />}><Interactionoverview /></Suspense>} path="/interactionoverview" />
                  <Route element={<Suspense fallback={<Loaders />}><CampaignReports /></Suspense>} path="/outboundcampaignreports" />
                  <Route element={<Suspense fallback={<Loaders />}><AgentParticularReport /></Suspense>} path="/agentparticularreport" />
                  <Route element={<Suspense fallback={<Loaders />}><Viewparticularhistory /></Suspense>} path="/viewparticularhistory" />
                  <Route element={<Suspense fallback={<Loaders />}><Usereports /></Suspense>} path="/usereports" />


                </Route>
                <Route element={<Suspense fallback={<Loaders />}><Login /></Suspense>} path="/login" />
                <Route element={<Suspense fallback={<Loaders />}><Login /></Suspense>} path="/" />
                {/* <Route element={<Suspense fallback={<Loaders />}><Login /></Suspense>} path="*" /> */}
                <Route element={<Suspense fallback={<Loaders />}><WhatsAppWebView /></Suspense>} path='/whatsappwebview' />
                <Route element={<Suspense fallback={<Loaders />}><WhatsappWebcallback /></Suspense>} path='/whatsappwebcallback' />
                <Route element={<Suspense fallback={<Loaders />}><FacebookWebcallback /></Suspense>} path='/facebookWebcallback' />
                <Route element={<Suspense fallback={<Loaders />}><InstagramWebcallback /></Suspense>} path='/instagramWebcallback' />
                <Route element={<Suspense fallback={<Loaders />}><UnsubscribeEmail /></Suspense>} path='/unsubscribe' />
                <Route element={<Suspense fallback={<Loaders />}><WhatsAppPaymentWebView /></Suspense>} path='/whatsapppaymentwebview' />
                <Route element={<Suspense fallback={<Loaders />}><Wix3ds /></Suspense>} path='wix3ds' />
                <Route element={<Suspense fallback={<Loaders />}><SpriteIcons /></Suspense>} path="/icons" />
                <Route element={<Suspense fallback={<Loaders />}><ResetPassWord /></Suspense>} path="/resetPassword" />
                <Route element={<Suspense fallback={<Loaders />}><NotFound /></Suspense>} path="/NotFound" />
                <Route element={<Suspense fallback={<Loaders />}><Settings /></Suspense>} path="/settings" />
                <Route element={<Suspense fallback={<Loaders />}><ChatbotOnboarding /></Suspense>} path="/chatbotonboarding" />
                <Route element={<Suspense fallback={<Loaders />}><CommonContainer /></Suspense>} path="/customervideochat/:id" />
                <Route element={<Suspense fallback={<Loaders />}><BroadCast /></Suspense>} path="/broadcast" />
              </Route>
            </Routes>
          </Suspense>

          {/*  
            for UI view
            */}
          <Routes>
            <Route element={<Suspense fallback={<Loaders />}><CsatEmailComponent /></Suspense>} path="/customersatisfaction/feedbackForms" />
            <Route element={<Suspense fallback={<Loaders />}><CsatFeedComponent /></Suspense>} path="/customersatisfaction/feedbackForm" />
          </Routes>

          <Suspense>
            <Routes>
              <Route element={<ControlledRoutes />}>
                <Route element={<Suspense fallback={<Loaders />}><BigcommerceLoad /></Suspense>} path="/bigcommerceload" />
                <Route element={<Suspense fallback={<Loaders />}><BigCommerceConnection /></Suspense>} path="/bigcommerceconnection" />
                <Route element={<Suspense fallback={<Loaders />}><WixOauthConnect /></Suspense>} path="/wixconnection" />
              </Route>
            </Routes>
          </Suspense>

          <Routes>
            <Route element={<Suspense fallback={<Loaders />}><ConnectorSuccesspage /></Suspense>} path='/connectorsuccess' />
            <Route element={<Suspense fallback={<Loaders />}><ConnectorUnSuccesspage /></Suspense>} path='/connectorUnSuccess' />
            <Route element={<Suspense fallback={<Loaders />}><StoreToken /></Suspense>} path="/storetoken" />
          </Routes>

        </div>
      </div>
    </>
  );
}
export default App;

